import {
  isArray,
  isEmpty,
  isObject,
  isPrimitive,
  isString
} from "./chunk-GX7V4YTP.js";

// src/Core.ts
var generateFromSimple = (key, params) => {
  if (isArray(params.value)) {
    return params.value.filter(Boolean).join(",");
  }
  if (isPrimitive(params.value)) {
    return `${params.value}`;
  }
  if (isObject(params.value)) {
    if (params.explode) {
      return Object.entries(params.value).map(([key2, value]) => `${key2}=${value || ""}`).join(",");
    } else {
      return Object.entries(params.value).map(([key2, value]) => `${key2},${value || ""}`).join(",");
    }
  }
  return void 0;
};
var generateFormParamterForCookie = (key, params) => {
  if (isEmpty(params.value)) {
    return `${key}=`;
  }
  if (isPrimitive(params.value)) {
    return `${key}=${params.value}`;
  }
  if (isArray(params.value)) {
    if (params.explode) {
      return params.value.map((item) => `${key}=${item}`).join("&");
    } else {
      return `${key}=${params.value.join(",")}`;
    }
  }
  if (isObject(params.value)) {
    if (params.explode) {
      return Object.entries(params.value).map(([k, v]) => `${k}=${v}`).join("&");
    } else {
      const value = Object.entries(params.value).map(([k, v]) => `${k},${v}`).join(",");
      return `${key}=${value}`;
    }
  }
  return `${key}=`;
};
var generateFormParamter = (key, params) => {
  return generateFormParamterAsURLSearchParams(key, params).toString();
};
var generateFormParamterAsURLSearchParams = (key, params) => {
  const instance = new URLSearchParams();
  if (isEmpty(params.value)) {
    instance.append(key.toString(), "");
    return instance;
  }
  if (isPrimitive(params.value)) {
    instance.append(key.toString(), params.value?.toString() ?? "");
    return instance;
  }
  if (isArray(params.value)) {
    if (params.explode) {
      params.value.map((item) => {
        instance.append(key.toString(), item.toString());
      });
    } else {
      instance.append(key.toString(), params.value.join(","));
    }
    return instance;
  }
  if (isObject(params.value)) {
    if (params.explode) {
      Object.entries(params.value).map(([k, v]) => {
        instance.append(k.toString(), v.toString());
      });
    } else {
      const value = Object.entries(params.value).map(([k, v]) => `${k},${v}`).join(",");
      instance.append(key.toString(), value);
    }
    return instance;
  }
  instance.append(key.toString(), "");
  return instance;
};
var generateSpaceDelimited = (key, params) => {
  return generateSpaceDelimitedAsURLSearchParams(key, params)?.toString().replace(/\+/g, "%20");
};
var generateSpaceDelimitedAsURLSearchParams = (key, params) => {
  const instance = new URLSearchParams();
  if (isArray(params.value)) {
    instance.append(key.toString(), params.value.join(" "));
    return instance;
  }
  if (isObject(params.value)) {
    const value = Object.entries(params.value).map(([k, v]) => `${k} ${v}`).join(" ");
    instance.append(key.toString(), value);
    return instance;
  }
  return void 0;
};
var generatePipeDelimitedParameter = (key, params) => {
  return generatePipeDelimitedParameterAsURLSearchParams(key, params)?.toString();
};
var generatePipeDelimitedParameterAsURLSearchParams = (key, params) => {
  const instance = new URLSearchParams();
  if (isArray(params.value)) {
    instance.append(key.toString(), params.value.join("|"));
    return instance;
  }
  if (isObject(params.value)) {
    const value = Object.entries(params.value).map(([k, v]) => `${k}|${v}`).join("|");
    instance.append(key.toString(), value);
    return instance;
  }
  return void 0;
};
var generateDeepObjectParameter = (key, params) => {
  return generateDeepObjectParameterAsURLSearchParams(key, params)?.toString();
};
var generateDeepObjectParameterAsURLSearchParams = (key, params) => {
  if (!isObject(params.value)) {
    return void 0;
  }
  const queryParams = new URLSearchParams();
  const flatObject = flatten(params.value);
  Object.entries(flatObject).map(([dotKeyName, primitiveValue]) => {
    const nestedKey = dotKeyName.split(".").map((k1) => `[${k1}]`).join("");
    queryParams.append(`${key}${nestedKey}`, primitiveValue?.toString() ?? "");
  });
  return queryParams;
};
var generateFromMatrix = (key, params) => {
  if (isEmpty(params.value)) {
    return `;${key}`;
  }
  if (isString(params.value)) {
    return `;${key}=${params.value}`;
  }
  if (isArray(params.value)) {
    if (params.explode) {
      return ";" + params.value.map((v) => `${key}=${v}`).join(";");
    } else {
      return `;${key}=${params.value.join(",")}`;
    }
  }
  if (isObject(params.value)) {
    if (params.explode) {
      const value = Object.entries(params.value).map(([k, v]) => `${k}=${v}`).join(";");
      return `;${value}`;
    } else {
      const value = Object.entries(params.value).map(([k, v]) => `${k},${v}`).join(",");
      return `;${key}=${value}`;
    }
  }
  return `;${key}`;
};
var generateFromLabel = (key, params) => {
  if (isEmpty(params.value)) {
    return ".";
  }
  if (isPrimitive(params.value)) {
    return `.${params.value}`;
  }
  if (isArray(params.value)) {
    return `.${params.value.join(".")}`;
  }
  if (isObject(params.value)) {
    if (params.explode) {
      const value = Object.entries(params.value).map(([k, v]) => `${k}=${v}`).join(".");
      return `.${value}`;
    } else {
      const value = Object.entries(params.value).map(([k, v]) => `${k}.${v}`).join(".");
      return `.${value}`;
    }
  }
  return ".";
};
function flatten(obj) {
  function recursive(path, data, flatted2) {
    for (const [key, value] of Object.entries(data)) {
      const currentPath = [...path, key];
      if (isObject(value)) {
        recursive(currentPath, value, flatted2);
      } else {
        flatted2[currentPath.join(".")] = value;
      }
    }
  }
  const flatted = {};
  recursive([], obj, flatted);
  return flatted;
}

export {
  generateFromSimple,
  generateFormParamterForCookie,
  generateFormParamter,
  generateFormParamterAsURLSearchParams,
  generateSpaceDelimited,
  generateSpaceDelimitedAsURLSearchParams,
  generatePipeDelimitedParameter,
  generatePipeDelimitedParameterAsURLSearchParams,
  generateDeepObjectParameter,
  generateDeepObjectParameterAsURLSearchParams,
  generateFromMatrix,
  generateFromLabel
};
//# sourceMappingURL=chunk-FTKOE5C2.js.map